/**
 * Parses zod error message key to be used with i18n.
 * Extracts the trailing numbers from a key, if they exists, to show pluralized messages or specific numbers.
 * Usage: only for zod error messages.
 * @param key - The key to parse.
 */
export default (key: string): [string, number[]] => {
  const numberMatches = [...key.matchAll(/\.(\d+)/g)]
  const trailingNumbers = numberMatches.map((match) => Number(match[1]))
  const keyWithoutTrailingNumbers = numberMatches.length > 0 ? key.replace(/\.\d+/g, '') : key

  return [keyWithoutTrailingNumbers, trailingNumbers]
}
